(function () {
    'use strict';

    angular.module("imApp").factory("stockPlacesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 2170,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
